import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbb73080"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project_info_edit" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"10px","flex-wrap":"wrap"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询项目信息报备")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看所有附件")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#909399","font-size":"12px"} }, "选择报备后，仅自动获取当前为空的信息，已填写的内容不会被覆盖", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_7 = { style: {"max-height":"calc(100vh - 300px)","overflow-y":"auto","padding-right":"6px"} }
const _hoisted_8 = { class: "sec_title" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title req-item" }, "渠道来源", -1))
const _hoisted_12 = { style: {"padding":"0 10px 10px"} }
const _hoisted_13 = { style: {"margin-top":"8px","display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px","color":"#606266"} }, "其他渠道：", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "工程地址", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "附件", -1))
const _hoisted_17 = { style: {"padding":"0 10px 10px"} }
const _hoisted_18 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("上传附件")
const _hoisted_20 = { class: "paste_tip" }
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "图纸附件", -1))
const _hoisted_24 = { style: {"padding":"0 10px 10px"} }
const _hoisted_25 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap"} }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("上传图纸")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"#909399"} }, "每份图纸可单独填写备注", -1))
const _hoisted_28 = ["href"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_30 = {
  key: 0,
  style: {"color":"#909399","font-size":"13px"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "房间号或区域", -1))
const _hoisted_32 = { style: {"padding":"0 10px 10px"} }
const _hoisted_33 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px","color":"#606266"} }, "房间号或区域：", -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("删除房间")
const _hoisted_36 = { style: {"width":"100%","margin-top":"6px"} }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_38 = {
  key: 0,
  style: {"width":"100%","color":"#67c23a","font-size":"12px","line-height":"1.7"}
}
const _hoisted_39 = {
  key: 1,
  style: {"width":"100%","color":"#f56c6c","font-size":"12px"}
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode("+ 添加颜色编号")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("+ 添加房间")
const _hoisted_42 = {
  key: 0,
  style: {"color":"#909399","font-size":"13px","margin-top":"6px"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#909399","font-size":"12px","margin-top":"6px"} }, " 颜色编号共25位：第1位大类别、第2位油漆类别、第3位工艺类别、第4位表面效果、第5位拼皮工艺、 第6-7位亮度、第8位类别、第9-12位边框木皮、第13-16位芯板木皮、第17-18位木料、第19-20位色系、 第21位固定“-”、第22-23位色度；第24-25位为流水号（不解析） ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "预约时间修改记录", -1))
const _hoisted_45 = { style: {"padding":"0 10px 10px"} }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("+ 添加修改记录")
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "跟踪记录", -1))
const _hoisted_49 = { style: {"padding":"0 10px 10px"} }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("+ 添加跟踪记录")
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sec_title",
  id: "sec-dc"
}, "数据收集 - 订单信息计划表", -1))
const _hoisted_53 = { style: {"padding":"0 10px 10px"} }
const _hoisted_54 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap","margin-bottom":"8px"} }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("加载/刷新")
const _hoisted_56 = /*#__PURE__*/_createTextVNode("+ 新增一行")
const _hoisted_57 = { style: {"color":"#909399","font-size":"12px"} }
const _hoisted_58 = {
  key: 0,
  style: {"color":"#909399","font-size":"13px"}
}
const _hoisted_59 = {
  key: 1,
  style: {"color":"#909399","font-size":"13px"}
}
const _hoisted_60 = { key: 2 }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { style: {"font-weight":"600","color":"#303133"} }
const _hoisted_63 = { class: "dc_toggle" }
const _hoisted_64 = {
  key: 0,
  style: {"color":"#909399","font-weight":"400","font-size":"12px"}
}
const _hoisted_65 = {
  key: 1,
  style: {"color":"#E6A23C","font-weight":"400","font-size":"12px"}
}
const _hoisted_66 = {
  key: 2,
  style: {"color":"#409EFF","font-weight":"400","font-size":"12px","margin-left":"8px"}
}
const _hoisted_67 = /*#__PURE__*/_createTextVNode("删除该行")
const _hoisted_68 = {
  key: 0,
  class: "readonly-tag"
}
const _hoisted_69 = {
  key: 4,
  style: {"width":"100%"}
}
const _hoisted_70 = ["href"]
const _hoisted_71 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_72 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_73 = {
  key: 0,
  style: {"margin-left":"10px","color":"#e6a23c","font-size":"12px"}
}
const _hoisted_74 = /*#__PURE__*/_createTextVNode("保存订单信息计划表")
const _hoisted_75 = { style: {"display":"flex","align-items":"center","gap":"10px","flex-wrap":"wrap","margin-bottom":"10px"} }
const _hoisted_76 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_77 = /*#__PURE__*/_createTextVNode("查看详情")
const _hoisted_78 = /*#__PURE__*/_createTextVNode("选用")
const _hoisted_79 = {
  class: "flexEnd",
  style: {"padding":"15px 0"}
}
const _hoisted_80 = /*#__PURE__*/_createTextVNode("关 闭")
const _hoisted_81 = { style: {"max-height":"calc(100vh - 220px)","overflow-y":"auto"} }
const _hoisted_82 = { class: "sec_title" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "工程地址", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "特殊要求", -1))
const _hoisted_85 = { key: 0 }
const _hoisted_86 = {
  key: 1,
  style: {"color":"#909399"}
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "预约时间修改记录", -1))
const _hoisted_88 = {
  key: 3,
  style: {"color":"#909399"}
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "跟踪记录", -1))
const _hoisted_90 = {
  key: 5,
  style: {"color":"#909399"}
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "图纸附件", -1))
const _hoisted_92 = { key: 6 }
const _hoisted_93 = ["href"]
const _hoisted_94 = { style: {"color":"#606266"} }
const _hoisted_95 = {
  key: 7,
  style: {"color":"#909399"}
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec_title" }, "附件", -1))
const _hoisted_97 = { key: 8 }
const _hoisted_98 = ["href"]
const _hoisted_99 = {
  key: 9,
  style: {"color":"#909399"}
}
const _hoisted_100 = /*#__PURE__*/_createTextVNode("关 闭")

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { apiName } from '@/api/api';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Search } from '@element-plus/icons-vue';
import { reqDataCollectGetTemplateAll, reqDataCollectDataList, reqDataCollectSaveData, reqDataCollectUpdateData, reqDataCollectDataDelete, reqDataCollectGetEditableUsers } from '@/api/datacollectApi';
import { requestMyuser } from '@/api/api';
import { reqProjectReportList, reqProjectReportDetails, reqProjectReportSave, reqProjectReportGetByProject } from '@/api/projectReportApi';
import { requestGetAllConfig } from '@/api/configApi';
import areaData from '@/utils/areaData';
import ProjectAllFiles from '@/components/ProjectAllFiles.vue';


export default /*#__PURE__*/_defineComponent({
  name: 'ProjectInfoEdit',
  props: {
	// 所属项目的 uuid 与名称（项目信息挂在项目下）
	projectuuid: { type: String, default: '' },
	projectname: { type: String, default: '' },
	// 项目编号：批次号为空时自动取项目编号
	projectcode: { type: String, default: '' },
	// 由"项目所有附件"跳转进来时定位的区块：dc=数据收集-订单信息计划表
	focusSection: { type: String, default: '' }
},
  emits: ['saved'],
  setup(__props, { expose, emit }) {

const props = __props



const api = ref<string>(apiName)

// ===== 字段配置（与"项目信息报备"字段完全一致）=====
const billTypes = ['项目', '家具']
const styTypes = ['常规款式', '高定款式']
const natures = ['公寓', '平层', '联排', '别墅', '会所', '自建房', '其他']
const pstyles = ['伟纳', '亚历山大', '大师定制', '风格', '欧式', '东方', '通用', '宋氏', '老钱', '其他']
const channels = ['原业主', '原业主介绍', '设计师推荐', '装饰设计公司推荐', '品牌联盟推荐', '其他渠道']
const results = ['通过', '不通过', '提交待审核']

// cols：该分组每行显示的字段数量
const groups: any[] = [
	{
		title: '基本信息',
		cols: 4,
		fields: [
			{ label: '报备有效期', prop: 'validdate', type: 'text', disabled: true, ph: '保存后自动生成（当前时间+3个月）' },
			{ label: '单据类型', prop: 'billtype', type: 'select', options: billTypes, req: true },
			{ label: '单据日期', prop: 'billdate', type: 'date', req: true },
			{ label: '报备人编号', prop: 'dealerno', type: 'text', req: true },
			{ label: '批次号', prop: 'batchno', type: 'text', ph: '自动取项目编号，可修改' },
			{ label: '报备联系人', prop: 'contact', type: 'text', req: true },
			{ label: '报备联系人电话', prop: 'contacttel', type: 'text', req: true },
			{ label: '项目名称', prop: 'projectname', type: 'text', req: true }
		]
	},
	{
		title: '项目信息',
		cols: 4,
		fields: [
			{ label: '款式', prop: 'stytype', type: 'select', options: styTypes, req: true },
			{ label: '项目性质', prop: 'nature', type: 'select', options: natures, req: true },
			{ label: '项目风格', prop: 'pstyle', type: 'select', options: pstyles, req: true },
			{ label: '预计平方数', prop: 'areasize', type: 'text', req: true },
			{ label: '主要材质木种', prop: 'woodtype', type: 'text' },
			{ label: '预计木作下单时间', prop: 'woodorderdate', type: 'date' },
			{ label: '是否跨区域', prop: 'crossregion', type: 'radio' },
			{ label: '是否开票', prop: 'invoice', type: 'radio' }
		]
	},
	{
		title: '备案结果与作废',
		cols: 3,
		fields: [
			{ label: '备案结果', prop: 'result', type: 'select', options: results },
			{ label: '备案结果备注', prop: 'resultremark', type: 'textarea' },
			{ label: '作废原因', prop: 'voidreason', type: 'textarea' },
			{ label: '备注', prop: 'remark', type: 'textarea' },
			{ label: '作废日期', prop: 'voiddate', type: 'text', disabled: true, ph: '作废时自动生成' }
		]
	}
]
// 参与"按报备自动补全"的字段（省市区等地址字段与附件也包含在内）
const allProps: string[] = []
groups.forEach((g: any) => g.fields.forEach((f: any) => allProps.push(f.prop)))
allProps.push('province', 'city', 'district', 'community', 'building', 'houseno', 'address', 'channelother')

const emptyForm = (): any => {
	const f: any = {
		uuid: '', infotype: 'project', projectuuid: props.projectuuid,
		province: '', city: '', district: '', community: '', building: '', houseno: '', address: '',
		channel: '', channelother: '', filelist: '',
		voidflag: 0, voiddate: ''
	}
	allProps.forEach((p: string) => { if (f[p] === undefined) f[p] = '' })
	f.billtype = '项目'
	f.result = '提交待审核'
	f.projectname = props.projectname || ''
	f.batchno = props.projectcode || ''//批次号默认自动取项目编号
	// 是否跨区域 / 是否开票：默认选中"否"(0)，避免未选中状态
	f.crossregion = 0
	f.invoice = 0
	return f
}
const form = ref<any>(emptyForm())
const channelList = ref<string[]>([])
const specials = ref<any[]>([])
const timeChanges = ref<any[]>([])
const tracks = ref<any[]>([])
const fileList = ref<any[]>([])
// 图纸附件：每份图纸配一个备注
const drawings = ref<any[]>([])

// ===== 房间号或区域（可多条，每个房间下可填多个颜色编号）=====
const rooms = ref<any[]>([])
// 颜色编号规则：起始位置（从1开始）与长度；第21位为固定值“-”
const colorRules = [
	{ cat: '大类别', start: 1, len: 1 },
	{ cat: '油漆类别', start: 2, len: 1 },
	{ cat: '工艺类别', start: 3, len: 1 },
	{ cat: '表面效果', start: 4, len: 1 },
	{ cat: '拼皮工艺', start: 5, len: 1 },
	{ cat: '亮度', start: 6, len: 2 },
	{ cat: '类别', start: 8, len: 1 },
	{ cat: '边框木皮', start: 9, len: 4 },
	{ cat: '芯板木皮', start: 13, len: 4 },
	{ cat: '木料', start: 17, len: 2 },
	{ cat: '色系', start: 19, len: 2 },
	{ cat: '色度', start: 22, len: 2 },
]
const COLOR_CODE_LEN = 25   // 颜色编号总长度（24-25位为流水号，不参与解析）
const COLOR_SPLIT_POS = 21  // 第21位固定为“-”
// 颜色配置字典：分类名 -> (编码 -> 含义)，来源于 config 表 type='颜色配置'
const colorDict = ref<any>({})
const loadColorDict = () => {
	requestGetAllConfig({ type: '颜色配置' }).then((res: any) => {
		if (res.status !== 1 || !res.datalist) return
		const d: any = {}
		;(res.datalist || []).forEach((r: any) => {
			const cat = r.key
			if (!d[cat]) d[cat] = {}
			d[cat][String(r.value)] = r.field0 || ''
		})
		colorDict.value = d
		// 字典到位后，重新解析已填写的编号
		rooms.value.forEach((rm: any) => (rm.colors || []).forEach((c: any) => decodeColor(c)))
	})
}
// 解析单个颜色编号：按位置取段，查字典得到含义，结果写入 c.detail（JSON）
const decodeColor = (c: any) => {
	c.detail = ''
	c.err = ''
	const code = String(c.code || '').trim()
	if (!code) return
	if (code.length !== COLOR_CODE_LEN) {
		c.err = `颜色编号应为 ${COLOR_CODE_LEN} 位，当前为 ${code.length} 位`
		return
	}
	if (code[COLOR_SPLIT_POS - 1] !== '-') {
		c.err = `第 ${COLOR_SPLIT_POS} 位应为固定值“-”`
		return
	}
	const arr: any[] = []
	for (const r of colorRules) {
		const seg = code.slice(r.start - 1, r.start - 1 + r.len)
		const dict = colorDict.value[r.cat] || {}
		arr.push({ name: r.cat, code: seg, meaning: dict[seg] === undefined ? '' : dict[seg] })
	}
	// 第24-25位为流水号，仅原样记录，不做解析
	arr.push({ name: '流水号', code: code.slice(23, 25), meaning: '' })
	c.detail = JSON.stringify(arr)
}
// 把解析结果格式化为一行展示文本
const colorDetailText = (c: any) => {
	if (!c.detail) return ''
	let arr: any[] = []
	try { arr = JSON.parse(c.detail) } catch (e) { return String(c.detail) }
	if (!Array.isArray(arr)) return String(c.detail)
	return arr.map((o: any) => o.meaning ? `${o.name}：${o.meaning}（${o.code}）` : `${o.name}：${o.code}`).join('；')
}
// 新增房间 / 新增颜色编号
const addRoom = () => rooms.value.push({ roomname: '', colors: [] })
const addRoomColor = (rm: any) => {
	if (!rm.colors) rm.colors = []
	rm.colors.push({ code: '', detail: '', err: '' })
}
const onDrawingSuccess = (res: any, file: any) => {
	if (res && res.errno === 0 && res.data && res.data[0]) {
		const rawName = res.data[0].name || ''
		drawings.value.push({
			url: res.data[0].url,
			name: rawName ? decodeURIComponent(rawName) : (file.name || '图纸'),
			remark: ''
		})
	} else {
		ElMessage.error('图纸上传失败')
	}
}
const addressEdited = ref<boolean>(false)

// ===== 省 / 市 / 区 级联 =====
const areaMap: any = areaData
const provinceList = computed(() => (areaMap.p || []).filter((v: string) => v && v !== '请选择'))
const cityList = computed(() => ((areaMap.c || {})[form.value.province] || []).filter((v: string) => v && v !== '请选择'))
const districtList = computed(() => ((areaMap.a || {})[`${form.value.province}-${form.value.city}`] || []))
const onProvinceChange = () => { form.value.city = ''; form.value.district = ''; buildAddress() }
const onCityChange = () => { form.value.district = ''; buildAddress() }
const buildAddress = () => {
	if (addressEdited.value) return
	const f = form.value
	f.address = `${f.province || ''}${f.city || ''}${f.district || ''}${f.community || ''}${f.building ? f.building + '幢' : ''}${f.houseno || ''}`
}

// ===== 附件 Ctrl + V 粘贴上传 =====
const pasteUploading = ref<boolean>(false)
const fileUrl = (f: any) => (f.response && f.response.data && f.response.data[0]) ? f.response.data[0].url : (f.url || '')
const uploadPasteFile = (file: File) => {
	pasteUploading.value = true
	const fd = new FormData()
	fd.append('file', file, file.name || ('paste_' + Date.now()))
	fetch(`${api.value}/frame/uploadfile1`, { method: 'POST', credentials: 'same-origin', body: fd })
		.then((r: any) => r.json())
		.then((res: any) => {
			if (res && res.errno === 0 && res.data && res.data[0]) {
				const rawName = res.data[0].name || ''
				const name = rawName ? decodeURIComponent(rawName) : (file.name || '附件')
				fileList.value.push({ name, url: res.data[0].url, response: { data: [{ url: res.data[0].url, name: rawName }] } })
				ElMessage.success('附件已上传')
			} else {
				ElMessage.error((res && res.msg) || '附件上传失败')
			}
		})
		.catch(() => ElMessage.error('附件上传失败'))
		.finally(() => { pasteUploading.value = false })
}
const onPaste = (e: ClipboardEvent) => {
	const items = e.clipboardData && e.clipboardData.items
	if (!items) return
	const files: File[] = []
	for (let i = 0; i < items.length; i++) {
		const it: any = items[i]
		if (it && it.kind === 'file' && it.getAsFile) {
			const f = it.getAsFile()
			if (f) files.push(f)
		}
	}
	if (files.length === 0) return
	e.preventDefault()
	files.forEach((f: File) => uploadPasteFile(f))
}
onMounted(() => {
	document.addEventListener('paste', onPaste)
	// 当前用户：用于数据收集字段的编辑权限判断
	requestMyuser({}).then((res: any) => {
		if (res.status === 1 && res.datalist && res.datalist.length > 0) {
			userName.value = res.datalist[0].name || ''
		}
	})
	// 颜色配置字典：用于解析颜色编号
	loadColorDict()
})
onBeforeUnmount(() => { document.removeEventListener('paste', onPaste) })

// ===== 查看当前项目所有附件 =====
const allFilesRef = ref<any>(null)
const openAllFiles = () => {
	if (!props.projectuuid) {
		ElMessage.warning('未获取到项目信息')
		return
	}
	if (allFilesRef.value) allFilesRef.value.open(props.projectuuid, props.projectname)
}

// ===== 查询项目信息报备 =====
const reportShow = ref<boolean>(false)
const reportLoading = ref<boolean>(false)
const reportList = ref<any[]>([])
const reportPage = ref<number>(1)
const reportTotal = ref<number>(0)
const reportSearch = ref<any>({ projectname: '', batchno: '', ownername: '' })
const openReport = () => {
	reportShow.value = true
	// 查询条件默认全部为空，由用户自行输入后查询
	reportSearch.value.projectname = ''
	reportSearch.value.batchno = ''
	reportSearch.value.ownername = ''
	getReportList()
}
const getReportList = () => {
	reportLoading.value = true
	reqProjectReportList({
		pageIndex: reportPage.value,
		pageSize: 10,
		infotype: 'report',
		projectname: reportSearch.value.projectname,
		batchno: reportSearch.value.batchno
	}).then((res: any) => {
		reportList.value = (res && res.data) || []
		reportTotal.value = (res && res.totalCount) || 0
		reportLoading.value = false
	})
}
// 查看报备详情
const reportDetailShow = ref<boolean>(false)
const reportDetailLoading = ref<boolean>(false)
const reportDetail = ref<any>({})
const openReportDetail = (row: any) => {
	reportDetailShow.value = true
	reportDetailLoading.value = true
	reportDetail.value = {}
	reqProjectReportDetails({ uuid: row.uuid }).then((res: any) => {
		reportDetailLoading.value = false
		if (res.status === 1) reportDetail.value = res.datalist
	})
}
// 选用报备：仅自动获取当前为空的信息
const fillFromReport = (row: any) => {
	reqProjectReportDetails({ uuid: row.uuid }).then((res: any) => {
		if (res.status !== 1) { ElMessage.error(res.msg || '加载报备失败'); return }
		const d = res.datalist
		const src = d.main || {}
		let count = 0
		// 主表字段：只填空的
		allProps.forEach((p: string) => {
			const v = src[p]
			if (v === undefined || v === null || String(v) === '') return
			if (form.value[p] === undefined || String(form.value[p]) === '') {
				form.value[p] = String(v)
				count++
			}
		})
		// radio 字段需转成数字才能与 :label="0"/1 匹配（选用报备带回的是字符串）
		form.value.crossregion = Number(form.value.crossregion) || 0
		form.value.invoice = Number(form.value.invoice) || 0
		// 特殊要求：当前为空时整组带入
		if (specials.value.length === 0 && d.specials && d.specials.length) {
			specials.value = d.specials.map((s: any) => ({ content: s.content || '' }))
			count++
		}
		// 预约时间修改记录
		if (timeChanges.value.length === 0 && d.timechanges && d.timechanges.length) {
			timeChanges.value = d.timechanges.map((s: any) => ({
				changetype: s.changetype || '', oldtime: s.oldtime || '', newtime: s.newtime || '',
				modifyuser: s.modifyuser || '', modifytime: s.modifytime || '', reason: s.reason || ''
			}))
			count++
		}
		// 跟踪记录
		if (tracks.value.length === 0 && d.tracks && d.tracks.length) {
			tracks.value = d.tracks.map((s: any) => ({
				tracktime: s.tracktime || '', trackuser: s.trackuser || '', trackway: s.trackway || '', conclusion: s.conclusion || ''
			}))
			count++
		}
		// 图纸附件（含备注）
		if (drawings.value.length === 0 && d.drawings && d.drawings.length) {
			drawings.value = d.drawings.map((s: any) => ({ url: s.url || '', name: s.name || '', remark: s.remark || '' }))
			count++
		}
		// 房间号或区域（含颜色编号）
		if (rooms.value.length === 0 && d.rooms && d.rooms.length) {
			rooms.value = d.rooms.map((s: any) => ({
				roomname: s.roomname || '',
				colors: (s.colors || []).map((c: any) => ({ code: c.code || '', detail: c.detail || '', err: '' }))
			}))
			count++
		}
		// 渠道来源
		if (channelList.value.length === 0 && src.channel) {
			channelList.value = String(src.channel).split(',').filter((v: string) => v)
		}
		// 附件：当前无附件时带入
		if (fileList.value.length === 0 && src.filelist) {
			fileList.value = String(src.filelist).split(',').filter((v: string) => v)
				.map((u: string, i: number) => ({ name: '附件' + (i + 1), url: u }))
		}
		buildAddress()
		reportShow.value = false
		ElMessage.success(count > 0 ? `已自动获取 ${count} 项空信息` : '当前信息已完整，无可自动获取的内容')
	})
}

// ===== 数据收集 - 订单信息计划表（按批次号=项目批次号自动关联）=====
const dcTemplate = ref<any>(null)
const dcFields = ref<any[]>([])
const dcRows = ref<any[]>([])
const dcEditableUsers = ref<string[]>([])//数据收集模板的可编辑人员（下一道填写人候选）
const userName = ref<string>('')//当前用户姓名（用于字段可编辑权限判断）
// 字段可编辑权限：editableusers 为空表示所有人可编辑，否则仅名单内用户可编辑
const canEditDcField = (f: any): boolean => {
	const eu = (f.editableusers || '').trim()
	if (!eu) return true
	if (!userName.value) return true//未获取到用户信息时默认可编辑，避免误锁
	const users = eu.split(',')
	for (let i = 0; i < users.length; i++) {
		if (users[i].trim() === userName.value) return true
	}
	return false
}
// 字段是否禁用（批次号固定不可改，或当前用户无该字段编辑权限）
const dcFieldDisabled = (f: any): boolean => f.fieldname === '批次号' || !canEditDcField(f)
// 允许选择"无（信息已完善）"的人员名单（在数据收集模板中配置）
const dcCompleteUsers = computed<string[]>(() => {
	const s = dcTemplate.value ? String(dcTemplate.value.complete_users || '') : ''
	return s.split(',').map((u: string) => u.trim()).filter((u: string) => u)
})
// 当前用户是否可将"下一道填写人"选为"无（信息已完善）"
// 规则与 DataCollectAdd 一致：名单为空表示所有人可选"无"；名单不为空时仅名单内人员可选"无"
const dcAllowComplete = computed<boolean>(() => {
	if (dcCompleteUsers.value.length === 0) return true
	return !!userName.value && dcCompleteUsers.value.includes(userName.value)
})
const parseDcFieldValues = (s: string): any[] => {
	if (!s) return []
	try { const a = JSON.parse(s); return Array.isArray(a) ? a : [] } catch (e) { return [] }
}
const dcValByFid = (fvs: any[], fid: any): string => {
	const one = fvs.find((v: any) => String(v.fieldid) === String(fid))
	return one ? (one.value || '') : ''
}
const dcValByName = (fvs: any[], name: string): string => {
	const one = fvs.find((v: any) => v.fieldname === name)
	return one ? (one.value || '') : ''
}
const dcOptions = (f: any): string[] => {
	try { const a = JSON.parse(f.fieldoptions || '[]'); return Array.isArray(a) ? a : [] } catch (e) { return [] }
}
const dcAttachList = (val: any): string[] => String(val || '').split(',').filter((u: string) => u)
const dcRemoveAttach = (r: any, f: any, idx: number) => {
	const arr = dcAttachList(r.values[f.id])
	arr.splice(idx, 1)
	r.values[f.id] = arr.join(',')
}
const dcAttachSuccess = (r: any, f: any, res: any) => {
	if (res && res.errno === 0 && res.data && res.data[0]) {
		const arr = dcAttachList(r.values[f.id])
		arr.push(res.data[0].url)
		r.values[f.id] = arr.join(',')
	} else {
		ElMessage.error('附件上传失败')
	}
}
// 加载模板与其数据：只保留"批次号 = 项目批次号"的记录
const loadDcRows = () => {
	reqDataCollectGetTemplateAll({}).then((res: any) => {
		if (res.status !== 1) return
		const t = (res.datalist || []).find((x: any) => String(x.name || '').indexOf('订单信息计划表') > -1)
		if (!t) { dcTemplate.value = null; dcFields.value = []; dcRows.value = []; return }
		dcTemplate.value = t
		dcFields.value = t.fields || []
		// 下一道填写人候选
		reqDataCollectGetEditableUsers({ templateid: t.id }).then((ru: any) => {
			dcEditableUsers.value = (ru.status === 1 && ru.datalist) ? ru.datalist : []
		})
		reqDataCollectDataList({ pageIndex: 1, pageSize: 200, templateid: t.id }).then((r2: any) => {
			const rows = (r2 && (r2.data || r2.DataMap)) || []
			const batchno = form.value.batchno || ''
			const list: any[] = []
			rows.forEach((row: any) => {
				const item = row.cell || row
				const fvs = parseDcFieldValues(item.fieldvalues)
				if (batchno && dcValByName(fvs, '批次号') !== batchno) return
				const values: any = {}
				dcFields.value.forEach((f: any) => { values[f.id] = dcValByFid(fvs, f.id) })
				// _open：记录展开/收缩状态
				list.push({ id: item.id, nexthandler: item.nexthandler || '', values, _open: true })
			})
			dcRows.value = list
		})
	})
}
// 新增一行（预填批次号，保证与项目关联）
const addDcRow = () => {
	if (!dcTemplate.value) { ElMessage.warning('未找到"订单信息计划表"模板'); return }
	const values: any = {}
	dcFields.value.forEach((f: any) => {
		values[f.id] = (f.fieldname === '批次号') ? (form.value.batchno || '') : ''
	})
	dcRows.value.push({ id: 0, nexthandler: '', values, _open: true })
}
// 删除一行（已存在的调用删除接口，未保存的行直接移除）
const delDcRow = (r: any, idx: number) => {
	if (!r.id) { dcRows.value.splice(idx, 1); return }
	ElMessageBox.confirm('确定删除该条订单信息计划表记录吗？', '提示', { type: 'warning' }).then(() => {
		reqDataCollectDataDelete({ id: r.id }).then((res: any) => {
			if (res.status === 1) { ElMessage.success('删除成功'); dcRows.value.splice(idx, 1) }
			else { ElMessage.error(res.msg || '删除失败') }
		})
	}).catch(() => {})
}
// 保存所有行（有 id 走更新，无 id 走新增）
const saveDcRows = () => {
	if (!dcTemplate.value) return
	const tasks: any[] = []
	dcRows.value.forEach((r: any) => {
		const values = dcFields.value.map((f: any) => ({
			fieldid: f.id, fieldname: f.fieldname, fieldtype: f.fieldtype, value: r.values[f.id] || ''
		}))
		if (r.id) {
			tasks.push(reqDataCollectUpdateData({ id: r.id, fieldvalues: JSON.stringify(values), nexthandler: r.nexthandler || '' }))
		} else {
			tasks.push(reqDataCollectSaveData({
				templateid: dcTemplate.value.id, templatename: dcTemplate.value.name,
				fieldvalues: JSON.stringify(values), nexthandler: r.nexthandler || ''
			}))
		}
	})
	if (tasks.length === 0) return
	Promise.all(tasks).then((list: any[]) => {
		let ok = 0
		list.forEach((res: any) => { if (res && res.status === 1) ok++ })
		ElMessage.success(`已保存 ${ok} / ${list.length} 条记录`)
		loadDcRows()
	})
}

// ===== 加载 / 保存 =====
// 由"项目所有附件"跳转进来时，滚动定位到指定区块（如 dc=数据收集-订单信息计划表）
const scrollToFocusSection = () => {
	if (!props.focusSection) return
	setTimeout(() => {
		const el = document.getElementById('sec-' + props.focusSection)
		if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
	}, 900)
}
const loading = ref<boolean>(false)
const load = () => {
	if (!props.projectuuid) return
	loading.value = true
	reqProjectReportGetByProject({ projectuuid: props.projectuuid }).then((res: any) => {
		loading.value = false
		if (res.status === 1 && res.datalist) {
			fillForm(res.datalist)
		}
		// 项目信息加载后自动带出订单信息计划表的关联记录（按批次号匹配）
		loadDcRows()
		scrollToFocusSection()
	})
}
const fillForm = (d: any) => {
	form.value = Object.assign(emptyForm(), d.main || {})
	form.value.infotype = 'project'
	form.value.projectuuid = props.projectuuid
	form.value.voidflag = Number(form.value.voidflag) || 0
	form.value.crossregion = Number(form.value.crossregion) || 0
	form.value.invoice = Number(form.value.invoice) || 0
	// 批次号为空时自动取项目编号（项目编号变更后由后端同步，这里兜底补全）
	if (!form.value.batchno && props.projectcode) form.value.batchno = props.projectcode
	channelList.value = form.value.channel ? String(form.value.channel).split(',').filter((v: string) => v) : []
	specials.value = (d.specials || []).map((s: any) => ({ content: s.content || '' }))
	timeChanges.value = (d.timechanges || []).map((s: any) => ({
		changetype: s.changetype || '', oldtime: s.oldtime || '', newtime: s.newtime || '',
		modifyuser: s.modifyuser || '', modifytime: s.modifytime || '', reason: s.reason || ''
	}))
	tracks.value = (d.tracks || []).map((s: any) => ({
		tracktime: s.tracktime || '', trackuser: s.trackuser || '', trackway: s.trackway || '', conclusion: s.conclusion || ''
	}))
	fileList.value = form.value.filelist ? String(form.value.filelist).split(',').filter((v: string) => v)
		.map((u: string, i: number) => ({ name: '附件' + (i + 1), url: u })) : []
	drawings.value = (d.drawings || []).map((s: any) => ({
		url: s.url || '', name: s.name || '', remark: s.remark || ''
	}))
	rooms.value = (d.rooms || []).map((s: any) => ({
		roomname: s.roomname || '',
		colors: (s.colors || []).map((c: any) => ({ code: c.code || '', detail: c.detail || '', err: '' }))
	}))
	addressEdited.value = true
}
const saving = ref<boolean>(false)
// ===== 必填项校验（与报备页口径一致）=====
const requiredFields: any[] = [
	{ prop: 'billtype', label: '单据类型' },
	{ prop: 'billdate', label: '单据日期' },
	{ prop: 'dealerno', label: '报备人编号' },
	{ prop: 'contact', label: '报备联系人' },
	{ prop: 'contacttel', label: '报备联系人电话' },
	{ prop: 'projectname', label: '项目名称' },
	{ prop: 'stytype', label: '款式' },
	{ prop: 'nature', label: '项目性质' },
	{ prop: 'pstyle', label: '项目风格' },
	{ prop: 'areasize', label: '预计平方数' },
	{ prop: 'channel', label: '渠道来源' },
	{ prop: 'address', label: '工程地址' }
]
// 返回第一个未填写的必填项名称；全部填写则返回空串
const checkRequired = (d: any, specialCount: number): string => {
	if (!d) return '数据'
	for (let i = 0; i < requiredFields.length; i++) {
		const f = requiredFields[i]
		const v = d[f.prop]
		if (v === undefined || v === null || String(v).trim() === '') return f.label
	}
	return ''
}

const save = () => {
	// 先把多选类的值写入 form，再做必填校验（否则渠道来源会误判为空）
	form.value.channel = channelList.value.join(',')
	// 必填项未填写完整：不允许保存（因此也无法把备案结果置为"通过"后再提交）
	const miss = checkRequired(form.value, specials.value.filter((s: any) => s.content).length)
	if (miss) {
		ElMessage.warning('请填写必填项：' + miss)
		return
	}
	form.value.filelist = fileList.value.map(fileUrl).filter((u: string) => u).join(',')
	form.value.infotype = 'project'
	form.value.projectuuid = props.projectuuid
	const params: any = Object.assign({}, form.value)
	params.specials = JSON.stringify(specials.value.filter((s: any) => s.content))
	params.timechanges = JSON.stringify(timeChanges.value)
	params.tracks = JSON.stringify(tracks.value)
	params.drawings = JSON.stringify(drawings.value.filter((d: any) => d.url))
	// 房间号/区域：保存前统一解析颜色编号，再随表单提交
	rooms.value.forEach((rm: any) => (rm.colors || []).forEach((c: any) => decodeColor(c)))
	params.rooms = JSON.stringify(rooms.value.filter((r: any) => {
		const name = String(r.roomname || '').trim()
		const hasColor = (r.colors || []).some((c: any) => String(c.code || '').trim())
		return name || hasColor
	}).map((r: any) => ({
		roomname: String(r.roomname || '').trim(),
		colors: (r.colors || []).filter((c: any) => String(c.code || '').trim())
			.map((c: any) => ({ code: String(c.code || '').trim(), detail: c.detail || '' }))
	})))
	saving.value = true
	reqProjectReportSave(params).then((res: any) => {
		saving.value = false
		if (res.status === 1) {
			ElMessage.success('保存成功')
			emit('saved')
		} else {
			ElMessage.error(res.msg || '保存失败')
		}
	}).catch(() => { saving.value = false })
}

expose({ load, save, saving })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        icon: _unref(Search),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openReport()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["icon"]),
      _createVNode(_component_el_button, {
        type: "warning",
        size: "small",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openAllFiles()))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(groups, (g, gi) => {
        return _createElementVNode("div", { key: gi }, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(g.title), 1),
          _createVNode(_component_el_form, {
            "label-width": "150px",
            class: _normalizeClass(g.cols===4 ? 'four-col-form' : (g.cols===3 ? 'three-col-form' : 'two-col-form'))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.fields, (f, fi) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: fi,
                  label: f.label,
                  class: _normalizeClass(f.req ? 'col-item req-item' : 'col-item')
                }, {
                  default: _withCtx(() => [
                    (f.type==='text')
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: form.value[f.prop],
                          "onUpdate:modelValue": ($event: any) => ((form.value[f.prop]) = $event),
                          placeholder: f.ph || '',
                          disabled: f.disabled
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"]))
                      : (f.type==='textarea')
                        ? (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            modelValue: form.value[f.prop],
                            "onUpdate:modelValue": ($event: any) => ((form.value[f.prop]) = $event),
                            type: "textarea",
                            rows: 2
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : (f.type==='date')
                          ? (_openBlock(), _createBlock(_component_el_date_picker, {
                              key: 2,
                              modelValue: form.value[f.prop],
                              "onUpdate:modelValue": ($event: any) => ((form.value[f.prop]) = $event),
                              type: "date",
                              "value-format": "YYYY-MM-DD",
                              style: {"width":"100%"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          : (f.type==='select')
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 3,
                                modelValue: form.value[f.prop],
                                "onUpdate:modelValue": ($event: any) => ((form.value[f.prop]) = $event),
                                placeholder: "请选择",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.options, (o, oi) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: o,
                                      value: o,
                                      key: oi
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"]))
                            : (f.type==='radio')
                              ? (_openBlock(), _createBlock(_component_el_radio_group, {
                                  key: 4,
                                  modelValue: form.value[f.prop],
                                  "onUpdate:modelValue": ($event: any) => ((form.value[f.prop]) = $event)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_radio, { label: 0 }, {
                                      default: _withCtx(() => [
                                        _hoisted_9
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_radio, { label: 1 }, {
                                      default: _withCtx(() => [
                                        _hoisted_10
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["label", "class"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["class"]),
          (g.title==='项目信息')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: channelList.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((channelList).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(channels, (t, i) => {
                        return _createVNode(_component_el_checkbox, {
                          label: t,
                          value: t,
                          key: i
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_input, {
                      modelValue: form.value.channelother,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.channelother) = $event)),
                      style: {"width":"300px"},
                      placeholder: "选择“其他渠道”时填写"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _hoisted_15,
                _createVNode(_component_el_form, {
                  "label-width": "150px",
                  class: "three-col-form"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "省",
                      class: "col-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.province,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.province) = $event)),
                          filterable: "",
                          placeholder: "请选择",
                          style: {"width":"100%"},
                          onChange: onProvinceChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(provinceList), (t, i) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: t,
                                value: t,
                                key: i
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "市",
                      class: "col-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.city,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.city) = $event)),
                          filterable: "",
                          placeholder: "请选择",
                          style: {"width":"100%"},
                          onChange: onCityChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityList), (t, i) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: t,
                                value: t,
                                key: i
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "区",
                      class: "col-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.district,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.district) = $event)),
                          filterable: "",
                          placeholder: "请选择",
                          style: {"width":"100%"},
                          onChange: buildAddress
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(districtList), (t, i) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: t,
                                value: t,
                                key: i
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "小区",
                      class: "col-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.community,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.community) = $event)),
                          onChange: buildAddress
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "幢",
                      class: "col-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.building,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.building) = $event)),
                          onChange: buildAddress
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "门牌号",
                      class: "col-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.houseno,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.houseno) = $event)),
                          onChange: buildAddress
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "工程地址",
                      class: "col-item req-item",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.address,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.address) = $event)),
                          placeholder: "根据省/市/区/小区/幢/门牌号自动生成，可修改",
                          onInput: _cache[11] || (_cache[11] = ($event: any) => (addressEdited.value = true))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ])
      }), 64)),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_el_upload, {
            action: `${api.value}/frame/uploadfile1`,
            "file-list": fileList.value,
            multiple: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["action", "file-list"]),
          _createElementVNode("span", _hoisted_20, _toDisplayString(pasteUploading.value ? '上传中…' : 'Ctrl+V 粘贴上传附件'), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (f, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            style: {"margin-top":"4px"}
          }, [
            _createElementVNode("a", {
              href: `${api.value}${fileUrl(f)}`,
              target: "_blank",
              style: {"color":"#409EFF","margin-right":"8px"}
            }, _toDisplayString(f.name || ('附件'+(i+1))), 9, _hoisted_21),
            _createVNode(_component_el_button, {
              type: "danger",
              link: "",
              size: "small",
              onClick: ($event: any) => (fileList.value.splice(i,1))
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128))
      ]),
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_upload, {
            action: `${api.value}/frame/uploadfile1`,
            "show-file-list": false,
            multiple: "",
            "on-success": onDrawingSuccess
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["action"]),
          _hoisted_27
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drawings.value, (d, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "row_card",
            style: {"margin-top":"8px"}
          }, [
            _createElementVNode("a", {
              href: `${api.value}${d.url}`,
              target: "_blank",
              style: {"color":"#409EFF","min-width":"180px"}
            }, _toDisplayString(d.name || ('图纸'+(i+1))), 9, _hoisted_28),
            _createVNode(_component_el_input, {
              modelValue: d.remark,
              "onUpdate:modelValue": ($event: any) => ((d.remark) = $event),
              placeholder: "图纸备注",
              style: {"width":"320px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_button, {
              type: "danger",
              link: "",
              size: "small",
              onClick: ($event: any) => (drawings.value.splice(i,1))
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128)),
        (drawings.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, "暂无图纸"))
          : _createCommentVNode("", true)
      ]),
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rooms.value, (rm, ri) => {
          return (_openBlock(), _createElementBlock("div", {
            key: ri,
            class: "row_card",
            style: {"flex-direction":"column","align-items":"flex-start"}
          }, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode(_component_el_input, {
                modelValue: rm.roomname,
                "onUpdate:modelValue": ($event: any) => ((rm.roomname) = $event),
                placeholder: "如：101房间",
                style: {"width":"200px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_el_button, {
                type: "danger",
                link: "",
                size: "small",
                onClick: ($event: any) => (rooms.value.splice(ri,1))
              }, {
                default: _withCtx(() => [
                  _hoisted_35
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((rm.colors || []), (c, ci) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: ci,
                  style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap","margin-bottom":"4px"}
                }, [
                  _createVNode(_component_el_input, {
                    modelValue: c.code,
                    "onUpdate:modelValue": ($event: any) => ((c.code) = $event),
                    placeholder: "请输入25位颜色编号",
                    style: {"width":"230px"},
                    onChange: ($event: any) => (decodeColor(c))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                  _createVNode(_component_el_button, {
                    type: "danger",
                    link: "",
                    size: "small",
                    onClick: ($event: any) => (rm.colors.splice(ci,1))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (c.detail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(colorDetailText(c)), 1))
                    : (c.code)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(c.err || '未匹配到详细信息，请检查编号'), 1))
                      : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createVNode(_component_el_button, {
                size: "small",
                onClick: ($event: any) => (addRoomColor(rm))
              }, {
                default: _withCtx(() => [
                  _hoisted_40
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128)),
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (addRoom()))
        }, {
          default: _withCtx(() => [
            _hoisted_41
          ]),
          _: 1
        }),
        (rooms.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, "暂无房间"))
          : _createCommentVNode("", true),
        _hoisted_43
      ]),
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeChanges.value, (r, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "row_card"
          }, [
            _createVNode(_component_el_input, {
              modelValue: r.changetype,
              "onUpdate:modelValue": ($event: any) => ((r.changetype) = $event),
              placeholder: "类型",
              style: {"width":"140px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_date_picker, {
              modelValue: r.oldtime,
              "onUpdate:modelValue": ($event: any) => ((r.oldtime) = $event),
              type: "date",
              "value-format": "YYYY-MM-DD",
              placeholder: "原预约时间",
              style: {"width":"150px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_date_picker, {
              modelValue: r.newtime,
              "onUpdate:modelValue": ($event: any) => ((r.newtime) = $event),
              type: "date",
              "value-format": "YYYY-MM-DD",
              placeholder: "新预约时间",
              style: {"width":"150px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: r.modifyuser,
              "onUpdate:modelValue": ($event: any) => ((r.modifyuser) = $event),
              placeholder: "修改人",
              style: {"width":"110px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_date_picker, {
              modelValue: r.modifytime,
              "onUpdate:modelValue": ($event: any) => ((r.modifytime) = $event),
              type: "date",
              "value-format": "YYYY-MM-DD",
              placeholder: "修改时间",
              style: {"width":"150px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: r.reason,
              "onUpdate:modelValue": ($event: any) => ((r.reason) = $event),
              placeholder: "修改原因",
              style: {"width":"200px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_button, {
              type: "danger",
              link: "",
              size: "small",
              onClick: ($event: any) => (timeChanges.value.splice(i,1))
            }, {
              default: _withCtx(() => [
                _hoisted_46
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128)),
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (timeChanges.value.push({changetype:'',oldtime:'',newtime:'',modifyuser:'',modifytime:'',reason:''})))
        }, {
          default: _withCtx(() => [
            _hoisted_47
          ]),
          _: 1
        })
      ]),
      _hoisted_48,
      _createElementVNode("div", _hoisted_49, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tracks.value, (r, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "row_card"
          }, [
            _createVNode(_component_el_date_picker, {
              modelValue: r.tracktime,
              "onUpdate:modelValue": ($event: any) => ((r.tracktime) = $event),
              type: "date",
              "value-format": "YYYY-MM-DD",
              placeholder: "时间",
              style: {"width":"150px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: r.trackuser,
              "onUpdate:modelValue": ($event: any) => ((r.trackuser) = $event),
              placeholder: "跟踪人员名称",
              style: {"width":"140px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: r.trackway,
              "onUpdate:modelValue": ($event: any) => ((r.trackway) = $event),
              placeholder: "跟踪方式",
              style: {"width":"140px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: r.conclusion,
              "onUpdate:modelValue": ($event: any) => ((r.conclusion) = $event),
              placeholder: "结论",
              style: {"width":"240px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_button, {
              type: "danger",
              link: "",
              size: "small",
              onClick: ($event: any) => (tracks.value.splice(i,1))
            }, {
              default: _withCtx(() => [
                _hoisted_50
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128)),
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (tracks.value.push({tracktime:'',trackuser:'',trackway:'',conclusion:''})))
        }, {
          default: _withCtx(() => [
            _hoisted_51
          ]),
          _: 1
        })
      ]),
      _hoisted_52,
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            icon: _unref(Search),
            onClick: _cache[15] || (_cache[15] = ($event: any) => (loadDcRows()))
          }, {
            default: _withCtx(() => [
              _hoisted_55
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (addDcRow()))
          }, {
            default: _withCtx(() => [
              _hoisted_56
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_57, " 自动关联：订单信息计划表的\"批次号\" = 项目批次号（" + _toDisplayString(form.value.batchno || '未填写') + "） ", 1)
        ]),
        (!dcTemplate.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, "未找到\"订单信息计划表\"模板（点击\"加载/刷新\"重试）"))
          : (dcRows.value.length===0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, "暂无关联记录"))
            : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dcRows.value, (r, ri) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: ri,
                    class: "dc_row"
                  }, [
                    _createElementVNode("div", {
                      class: "dc_row_head",
                      onClick: ($event: any) => (r._open = !r._open)
                    }, [
                      _createElementVNode("span", _hoisted_62, [
                        _createElementVNode("span", _hoisted_63, _toDisplayString(r._open ? '收起 ▲' : '展开 ▼'), 1),
                        _createTextVNode(" 记录 " + _toDisplayString(Number(ri)+1) + " ", 1),
                        (r.id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_64, "（ID:" + _toDisplayString(r.id) + "）", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_65, "（新增，需保存）")),
                        (r.nexthandler)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_66, " 下一道：" + _toDisplayString(r.nexthandler), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_button, {
                        type: "danger",
                        link: "",
                        size: "small",
                        onClick: _withModifiers(($event: any) => (delDcRow(r,ri)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_67
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 8, _hoisted_61),
                    _withDirectives(_createElementVNode("div", null, [
                      _createVNode(_component_el_form, {
                        "label-width": "140px",
                        class: "three-col-form"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dcFields.value, (f, fi) => {
                            return (_openBlock(), _createBlock(_component_el_form_item, {
                              key: fi,
                              class: "col-item"
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(f.fieldname), 1),
                                (!canEditDcField(f))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, "无编辑权限"))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                (f.fieldtype==='text')
                                  ? (_openBlock(), _createBlock(_component_el_input, {
                                      key: 0,
                                      modelValue: r.values[f.id],
                                      "onUpdate:modelValue": ($event: any) => ((r.values[f.id]) = $event),
                                      disabled: dcFieldDisabled(f)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                  : (f.fieldtype==='textarea')
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        modelValue: r.values[f.id],
                                        "onUpdate:modelValue": ($event: any) => ((r.values[f.id]) = $event),
                                        type: "textarea",
                                        rows: 2,
                                        disabled: dcFieldDisabled(f)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                    : (f.fieldtype==='date')
                                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                          key: 2,
                                          modelValue: r.values[f.id],
                                          "onUpdate:modelValue": ($event: any) => ((r.values[f.id]) = $event),
                                          type: "date",
                                          "value-format": "YYYY-MM-DD",
                                          style: {"width":"100%"},
                                          disabled: dcFieldDisabled(f)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                      : (f.fieldtype==='select')
                                        ? (_openBlock(), _createBlock(_component_el_select, {
                                            key: 3,
                                            modelValue: r.values[f.id],
                                            "onUpdate:modelValue": ($event: any) => ((r.values[f.id]) = $event),
                                            style: {"width":"100%"},
                                            disabled: dcFieldDisabled(f)
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dcOptions(f), (o, oi) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  label: o,
                                                  value: o,
                                                  key: oi
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                        : (f.fieldtype==='attachment')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dcAttachList(r.values[f.id]), (u, ui) => {
                                                return (_openBlock(), _createElementBlock("div", { key: ui }, [
                                                  _createElementVNode("a", {
                                                    href: `${api.value}${u}`,
                                                    target: "_blank",
                                                    style: {"color":"#409EFF","margin-right":"8px"}
                                                  }, "附件" + _toDisplayString(Number(ui)+1), 9, _hoisted_70),
                                                  (canEditDcField(f))
                                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                                        key: 0,
                                                        type: "danger",
                                                        link: "",
                                                        size: "small",
                                                        onClick: ($event: any) => (dcRemoveAttach(r,f,ui))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _hoisted_71
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128)),
                                              (canEditDcField(f))
                                                ? (_openBlock(), _createBlock(_component_el_upload, {
                                                    key: 0,
                                                    action: `${api.value}/frame/uploadfile1`,
                                                    "show-file-list": false,
                                                    "on-success": (res)=>dcAttachSuccess(r,f,res)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_button, {
                                                        size: "small",
                                                        type: "primary"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _hoisted_72
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["action", "on-success"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_input, {
                                              key: 5,
                                              modelValue: r.values[f.id],
                                              "onUpdate:modelValue": ($event: any) => ((r.values[f.id]) = $event),
                                              disabled: dcFieldDisabled(f)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_el_form_item, {
                            label: "下一道填写人",
                            class: "col-item",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: r.nexthandler,
                                "onUpdate:modelValue": ($event: any) => ((r.nexthandler) = $event),
                                filterable: "",
                                clearable: _unref(dcAllowComplete),
                                placeholder: "无（信息已完善）",
                                style: {"width":"300px"}
                              }, {
                                default: _withCtx(() => [
                                  (_unref(dcAllowComplete))
                                    ? (_openBlock(), _createBlock(_component_el_option, {
                                        key: 0,
                                        label: "无（信息已完善）",
                                        value: ""
                                      }))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dcEditableUsers.value, (u, ui) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: u,
                                      value: u,
                                      key: ui
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "clearable"]),
                              (!_unref(dcAllowComplete))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_73, "您不在该模板\"可选无\"的人员名单内，必须指定具体填写人"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ], 512), [
                      [_vShow, r._open]
                    ])
                  ]))
                }), 128)),
                _createVNode(_component_el_button, {
                  type: "success",
                  size: "small",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (saveDcRows()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_74
                  ]),
                  _: 1
                })
              ]))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: reportShow.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((reportShow).value = $event)),
      title: "查询项目信息报备",
      width: "70%",
      "append-to-body": "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[23] || (_cache[23] = ($event: any) => (reportShow.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_80
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_75, [
          _createVNode(_component_el_input, {
            modelValue: reportSearch.value.projectname,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((reportSearch.value.projectname) = $event)),
            size: "small",
            placeholder: "项目名称",
            style: {"width":"160px"},
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_input, {
            modelValue: reportSearch.value.batchno,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((reportSearch.value.batchno) = $event)),
            size: "small",
            placeholder: "批次号",
            style: {"width":"130px"},
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_input, {
            modelValue: reportSearch.value.ownername,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((reportSearch.value.ownername) = $event)),
            size: "small",
            placeholder: "业主",
            style: {"width":"130px"},
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (getReportList()))
          }, {
            default: _withCtx(() => [
              _hoisted_76
            ]),
            _: 1
          })
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: reportList.value,
          border: "",
          size: "small",
          "highlight-current-row": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "cell.billtype",
              label: "单据类型",
              width: "90",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.billdate",
              label: "单据日期",
              width: "110",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.projectname",
              label: "项目名称",
              "min-width": "160",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.batchno",
              label: "批次号",
              width: "110"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.dealerno",
              label: "报备人编号",
              width: "110"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.createtime",
              label: "创建时间",
              width: "150",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "140",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (openReportDetail(scope.row.cell))
                }, {
                  default: _withCtx(() => [
                    _hoisted_77
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "success",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (fillFromReport(scope.row.cell))
                }, {
                  default: _withCtx(() => [
                    _hoisted_78
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, reportLoading.value]
        ]),
        _createElementVNode("div", _hoisted_79, [
          _createVNode(_component_el_pagination, {
            onCurrentChange: getReportList,
            currentPage: reportPage.value,
            "onUpdate:currentPage": _cache[22] || (_cache[22] = ($event: any) => ((reportPage).value = $event)),
            "page-size": 10,
            layout: "total, prev, pager, next",
            total: reportTotal.value
          }, null, 8, ["currentPage", "total"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ProjectAllFiles, {
      ref_key: "allFilesRef",
      ref: allFilesRef
    }, null, 512),
    _createVNode(_component_el_dialog, {
      modelValue: reportDetailShow.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((reportDetailShow).value = $event)),
      title: "项目信息报备详情",
      width: "80%",
      "append-to-body": "",
      top: "5vh"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (reportDetailShow.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_100
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_81, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(groups, (g, gi) => {
            return _createElementVNode("div", { key: gi }, [
              _createElementVNode("div", _hoisted_82, _toDisplayString(g.title), 1),
              _createVNode(_component_el_descriptions, {
                column: 2,
                border: "",
                size: "small"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.fields, (f, fi) => {
                    return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                      key: fi,
                      label: f.label
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main[f.prop] || '-') : '-'), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ])
          }), 64)),
          _hoisted_83,
          _createVNode(_component_el_descriptions, {
            column: 2,
            border: "",
            size: "small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "省" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main.province || '-') : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "市" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main.city || '-') : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "区" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main.district || '-') : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "小区" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main.community || '-') : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "幢" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main.building || '-') : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "门牌号" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main.houseno || '-') : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, {
                label: "工程地址",
                span: 2
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main.address || '-') : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "渠道来源" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main.channel || '-') : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "其他渠道" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reportDetail.value.main ? (reportDetail.value.main.channelother || '-') : '-'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_84,
          (reportDetail.value.specials && reportDetail.value.specials.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportDetail.value.specials, (s, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(Number(i)+1) + "、" + _toDisplayString(s.content), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_86, "无")),
          _hoisted_87,
          (reportDetail.value.timechanges && reportDetail.value.timechanges.length)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 2,
                data: reportDetail.value.timechanges,
                border: "",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "changetype",
                    label: "类型",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "oldtime",
                    label: "原预约时间",
                    width: "130"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "newtime",
                    label: "新预约时间",
                    width: "130"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "modifyuser",
                    label: "修改人",
                    width: "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "modifytime",
                    label: "修改时间",
                    width: "130"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "reason",
                    label: "修改原因",
                    "min-width": "160"
                  })
                ]),
                _: 1
              }, 8, ["data"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_88, "无")),
          _hoisted_89,
          (reportDetail.value.tracks && reportDetail.value.tracks.length)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 4,
                data: reportDetail.value.tracks,
                border: "",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "tracktime",
                    label: "时间",
                    width: "130"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "trackuser",
                    label: "跟踪人员",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "trackway",
                    label: "跟踪方式",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "conclusion",
                    label: "结论",
                    "min-width": "200"
                  })
                ]),
                _: 1
              }, 8, ["data"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_90, "无")),
          _hoisted_91,
          (reportDetail.value.drawings && reportDetail.value.drawings.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportDetail.value.drawings, (dg, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    style: {"margin-bottom":"6px"}
                  }, [
                    _createElementVNode("a", {
                      href: `${api.value}${dg.url}`,
                      target: "_blank",
                      style: {"color":"#409EFF","margin-right":"10px"}
                    }, _toDisplayString(dg.name || ('图纸'+(Number(i)+1))), 9, _hoisted_93),
                    _createElementVNode("span", _hoisted_94, "备注：" + _toDisplayString(dg.remark || '-'), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_95, "无")),
          _hoisted_96,
          (reportDetail.value.main && reportDetail.value.main.filelist)
            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportDetail.value.main.filelist.split(','), (v, i) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: i,
                    href: `${api.value}${v}`,
                    target: "_blank",
                    style: {"color":"#409EFF","margin-right":"10px"}
                  }, "附件" + _toDisplayString(Number(i)+1), 9, _hoisted_98))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_99, "无"))
        ])), [
          [_directive_loading, reportDetailLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})